module.exports = __webpack_public_path__ + "static/media/outing.0ef30bae.svg";